import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { getValidationByPlatform } from "selectors/Social2";

import { Layout, Icon } from "rhombus-react";

import { noop } from "utils/common";
import { PLATFORMS } from "utils/constants";

import PlatformTab from "./PlatformTab";

import "./SocialPlatformTabs.css";

export const PLATFORM_TABS = {
	"Shared Content": {
		label: "Shared Content",
		value: "Shared Content",
	},
	[PLATFORMS.FACEBOOK]: {
		value: PLATFORMS.FACEBOOK,
		renderLabel(tabData){
			return (
				<PlatformTab {...tabData}>
					<Icon name="fab fa-meta meta-logo" />
				</PlatformTab>
			);
		},
	},
	[PLATFORMS.FACEBOOK_MO]: {
		value: PLATFORMS.FACEBOOK_MO,
		renderLabel(tabData){
			return (
				<PlatformTab {...tabData}>
					<Icon name="fab fa-meta meta-logo" />
				</PlatformTab>
			);
		},
	},
	[PLATFORMS.GOOGLE]: {
		value: PLATFORMS.GOOGLE,
		renderLabel(tabData){
			return <PlatformTab {...tabData}><img className="logo" src="/images/GoogleDiscovery.png" /></PlatformTab>;
		},
	},
	[PLATFORMS.LINKEDIN]: {
		value: PLATFORMS.LINKEDIN,
		renderLabel(tabData){
			return <PlatformTab {...tabData}><Icon name="fab fa-linkedin" /></PlatformTab>;
		},
	},
	[PLATFORMS.PINTEREST]: {
		value: PLATFORMS.PINTEREST,
		renderLabel(tabData){
			return <PlatformTab {...tabData}><Icon name="fab fa-pinterest" /></PlatformTab>;
		},
	},
	[PLATFORMS.SNAPCHAT]: {
		value: PLATFORMS.SNAPCHAT,
		renderLabel(tabData){
			return <PlatformTab {...tabData}><Icon name="fab fa-snapchat" /></PlatformTab>;
		},
	},
	[PLATFORMS.TIKTOK]: {
		label: "TikTok",
		value: PLATFORMS.TIKTOK,
		renderLabel(tabData){
			return <PlatformTab {...tabData}><Icon name="fab fa-tiktok tiktok-logo" /></PlatformTab>;
		},
	},
	[PLATFORMS.TWITTER]: {
		value: PLATFORMS.TWITTER,
		renderLabel(tabData){
			return <PlatformTab {...tabData}><Icon name="fab fa-x-twitter x-twitter-logo" /></PlatformTab>;
		},
	},
	[PLATFORMS.YOUTUBE]: {
		value: PLATFORMS.YOUTUBE,
		renderLabel(tabData){
			return <PlatformTab {...tabData}><Icon name="fab fa-youtube" /></PlatformTab>;
		},
	},
};

export default function SocialPlatformTabs(props){
	const {
		adTypes,
		selectedAdType,

		onTabChange,
	} = props;

	const validationByPlatform = useSelector(getValidationByPlatform);

	const tabs = useMemo(() => {
		const platformSet = new Set(adTypes.map(item => item.platform));
		const platformTabs = [...platformSet].map((platform) => {
			const validation = validationByPlatform[platform] || {};
			return {
				...PLATFORM_TABS[platform],
				...validation,
			};
		});

		if(adTypes.length > 1){
			return [PLATFORM_TABS["Shared Content"], ...platformTabs];
		}
		return platformTabs;
	}, [adTypes, validationByPlatform]);


	const selectedTab = useMemo(() => {
		const selectedPlatform = selectedAdType?.platform;

		return tabs.find(item => item.value === selectedPlatform) || tabs?.[0];
	}, [tabs, selectedAdType]);

	return (
		<Layout.Tabs
			tabs = {tabs}
			onTabChange = {onTabChange}
			selectedTab = {selectedTab}
			className = "social-platform-tabs"
		/>
	);
}

SocialPlatformTabs.displayName = "SocialPlatformTabs";

SocialPlatformTabs.propTypes = {
	adTypes: PropTypes.array,
	selectedAdType: PropTypes.object,
	onTabChange: PropTypes.func,
};

SocialPlatformTabs.defaultProps = {
	onTabChange: noop,
};
